module.exports = __webpack_public_path__ + "static/media/link-icon.e7d3cbe0.svg";